import { getCookieByName } from '@99designs/browser';

export default function getCsrfToken() {
    return getCookieByName('_99csrf', typeof document !== 'undefined' ? document.cookie : '');
}
